import React from 'react';
import { Search } from 'lucide-react';
import './DataToolbar.css';

export interface ToolbarAction {
  key: string;
  label: string;
  icon?: React.ReactNode;
  /** mostra o caret de dropdown (▾) ao lado do label */
  hasCaret?: boolean;
  onClick?: () => void;
  title?: string;
}

export interface DataToolbarProps {
  title: React.ReactNode;
  /** busca (controlada). Se omitido, o campo de busca não é renderizado */
  searchValue?: string;
  searchPlaceholder?: string;
  onSearchChange?: (value: string) => void;
  /** botões secundários (Export, Filter, Show/Hide, Archive, ⋮ ...) */
  actions?: ToolbarAction[];
  /** botão primário azul à direita (ex.: "+ Novo") */
  primaryLabel?: string;
  primaryIcon?: React.ReactNode;
  onPrimary?: () => void;
}

/**
 * Barra de cabeçalho de listagens: título à esquerda; busca + ações + botão
 * primário à direita. Genérico/reutilizável — configurado via props.
 */
const DataToolbar: React.FC<DataToolbarProps> = ({
  title,
  searchValue,
  searchPlaceholder = 'Buscar...',
  onSearchChange,
  actions = [],
  primaryLabel,
  primaryIcon,
  onPrimary,
}) => {
  const showSearch = onSearchChange !== undefined;

  return (
    <div className="dt-toolbar">
      <h1 className="dt-toolbar-title">{title}</h1>

      <div className="dt-toolbar-right">
        {showSearch && (
          <div className="dt-search">
            <Search size={15} className="dt-search-icon" />
            <input
              className="dt-search-input"
              type="text"
              value={searchValue ?? ''}
              placeholder={searchPlaceholder}
              onChange={(e) => onSearchChange?.(e.target.value)}
            />
          </div>
        )}

        {actions.length > 0 && (
          <div className="dt-actions">
            {actions.map((a) => (
              <button
                key={a.key}
                type="button"
                className="dt-action-btn"
                onClick={a.onClick}
                title={a.title ?? a.label}
              >
                {a.icon && <span className="dt-action-icon">{a.icon}</span>}
                <span className="dt-action-label">{a.label}</span>
                {a.hasCaret && <span className="dt-action-caret">▾</span>}
              </button>
            ))}
          </div>
        )}

        {primaryLabel && (
          <button type="button" className="dt-primary-btn" onClick={onPrimary}>
            {primaryIcon}
            <span>{primaryLabel}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default DataToolbar;
